import { render, staticRenderFns } from "./SensorsCreateEdit.vue?vue&type=template&id=289ff304"
import script from "./SensorsCreateEdit.vue?vue&type=script&lang=js"
export * from "./SensorsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports